exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".BlockAppNavbar {\n  padding: 10px 0; }\n  .BlockAppNavbar .user-profile {\n    min-width: 280px;\n    margin: 0;\n    padding: 10px; }\n  .BlockAppNavbar .user-profile--avatar {\n    border-radius: 50%; }\n  .BlockAppNavbar .user-profile--name {\n    font-weight: bold; }\n  .BlockAppNavbar .user-profile--position {\n    opacity: 0.8;\n    font-size: 0.8rem; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/lib/loader.js!./src/blocks/AppNavbar.scss
// module id = 173
// module chunks = 0